<div class="card-header">
  <h1>Activeer uw account</h1>
</div>
<div class="card-body">
  <p>
    U heeft een activatie-email ontvangen. Kopieer-plak de activatie-code in het onderstaande veld. <br>
    Heeft u geen activatie-email ontvangen? Controleer dan de spambox of
    <span (click)="resendActivationCode()" class="link">verstuur de activatie-email opnieuw.</span>
  </p>

  <div class="spacer-small"></div>

  <div class="activation-code">
    <label for="code">Activatie code</label> <br>
    <input (ngModelChange)="codeChanged($event)" [(ngModel)]="code" id="code" maxLength="15" placeholder="XXX-XXX-XXX-XXX"
           type="text">
    <div *ngIf="code != null && code.length >= 15" style="color:red;">{{error}}</div>
  </div>
</div>
